import React, { Component } from 'react';
import { Collapse, Row, Col, Spin, message, Modal, Button } from 'antd';
import BiographicData from './NiprBiographicData';
import Address from './NiprAddress';
import Contact from './NiprContact';
import WebInformation from './NiprWebInformation'
import Aliases from './NiprAliases';
import Affiliations from './NiprAffiliations';
import NiprEmploymentHistory from './NiprEmploymentHistory';
import NiprBQ from './NiprBQ';
import NiprAttestation from './NiprAttestation';
import NiprNQ from './NiprNQ';
import MiCompAPI from '../../../util/api';
import moment from 'moment';
import NiprSummary from './NiprSummary';
import NiprRes from './NiprRes';
import img from '../../../assets/img/Illustration.png';

const { Panel } = Collapse;
class MyNipr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultActiveKey: 1,
            applicant: null,
            noN_UNIFORM: [],
            name: {},
            bqs: [],
            nuqs: [],
            States: [],
            predata:null,
            currentstep: 0,
            niprresp: null,
            stateName: null,
            stateabb: null,
            isloding: false,
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    getstatename(abb) {
        return this.state.States.find(x => x.code === abb).name
    }
    componentDidMount() {
        this.getClientMasters();
        if (this.props.location.state) {
            let { etype, res_state, record } = this.props.location.state;
            this.setState({
                stateName: record.stateName,
                stateabb: res_state,
            });
            this.api.invoke(
                "GetBackGroundQuestionByEType/" + etype,
                "get",
                (data, success) => {
                    if (success) {
                        this.setState({
                            bqs: data.data.map(x => { return { ...x, ans: 'n' } }),

                        });
                    }
                }
            );
            this.api.invoke(
                "NIPRPre",
                "get",
                (data, success) => {
                    if (success) {
                        this.setState({
                            predata: data.data,
                        });
                    }
                }
            );
            this.api.invoke(
                "GetNUQuestionByEType",
                "post",
                (data, success) => {
                    if (success) {
                        this.setState({
                            nuqs: data.data.map(x => { return { ...x, ans: 'n' } }),

                        });
                    }
                }, {
                eType: etype,
                state: res_state,
                lClass: ""
            }
            );
        }

    }

    niprappoinment = () => {
        let { etype, license_num, res_state, ssn, record } = this.props.location.state;
        let { classCode, code, fee } = record;
        let { processingFee, stateFee, transactionFee, } = fee;

        let data = {
            transaction: {
                // cusT_BATCH:Math.floor(Math.random()*10000000),
                // cusT_TRANS:Math.floor(Math.random()*10000000),
                tranS_FEE: transactionFee,
                procesS_FEE: processingFee,
                statE_FEE: stateFee,
                license: {
                    licensE_CLASS: classCode,
                    datE_EFFECTIVE: moment(new Date()).format("YYYYMMDD"),
                    countY_CODE: '1',
                    loa: {
                        loA_CODE: code
                    },
                },
                tranS_HEAD: {
                    transactioN_TYPE: !license_num ? (etype === "RL" ? '07' : '04') : (etype === "RLR" ? '08' : '05'),
                    statE_CODE: res_state,
                    datE_STAMP: moment(new Date()).format("YYYYMMDD"),
                    timE_STAMP: moment(new Date()).format("hhmmssmmm").substring(0, 9),
                },

                applicant: {
                    ...this.state.applicant, taX_NUM: ssn, countrY_CODE: '1', phone: this.state.applicant.phone.map(x => {
                        return { ...x, phonE_NUMBER: x.phonE_NUMBER.replace("+1 (", "").replace(") ", "").replace("-", "") }
                    })
                },
                noN_UNIFORM: this.state.noN_UNIFORM
            }
        };
        this.setState({
            isloding: true
        })
        this.api.invoke(
            "NIPR_GW",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {

                        this.setState({ niprresp: data.data })
                        
                        if ((this.state.currentstep === 2)&& data.data && data.data.transaction && data.data.transaction.license && !data.data.transaction.license.response && data.data.transaction.license.loa && !data.data.transaction.license.loa.response)
                            this.setState({
                                currentstep: this.state.currentstep + 1
                            })
                        if (this.state.currentstep === 1 
                            && data.data.transaction.license.response&&data.data.transaction.license.response.resP_MESSAGE.length===1&&data.data.transaction.license.response.resP_MESSAGE.filter(x=>x.commenT_CODE!=="1").length===0 && 
                            data.data.transaction.license.loa &&!data.data.transaction.license.loa.response)
                            this.setState({
                                isloding: false,
                                currentstep: this.state.currentstep + 1
                            })
                    } else {
                        this.setState({ niprresp: data.data })
                        message.destroy();
                      //  message.error(data.statusMessage, 3);
                    }
                    this.setState({
                        isloding: false
                    })
                }

            },
            data
        );
    };
    submitHandlerStep = (val) => {
        
        if (this.state.currentstep === 2) {
            this.setState({
                applicant: { ...this.state.applicant,...val },
            })
            setTimeout(() => {
                this.niprappoinment();

            }, 100);
        }    
        else if (this.state.currentstep === 1) {
           
            setTimeout(() => {
                this.niprappoinment();
            }, 100);
        }
        else {
            this.setState({
                applicant: { ...this.state.applicant,...val },
            })
            this.setState({
                currentstep: this.state.currentstep + 1
            })
        }
    }
    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({
                        States: data.states,
                    });

                }
            },
            ["STATE"]
        );
    }
    submitHandler = (val) => {
        
        if (this.state.defaultActiveKey === 1) {
            this.setState({
                name: {
                    namE_CODE: val.namE_CODE,
                    firM_OR_LAST_NAME: val.namE_CODE,
                    firsT_NAME: val.firsT_NAME,
                    middlE_NAME: val.middlE_NAME,
                    suffiX_NAME: val.suffiX_NAME
                },
                applicant: { ...this.state.applicant, ...val }

            })
            this.setState({
                defaultActiveKey: this.state.defaultActiveKey + 1
            })
        }
        else if (this.state.defaultActiveKey === 9) {
            this.setState({
                noN_UNIFORM: val,
                currentstep: this.state.currentstep + 1,
                applicant: { ...this.state.applicant, name: [this.state.name, ...this.state.applicant.name] },
            })
        }
        else {

            if (this.state.nuqs.length === 0 && this.state.defaultActiveKey === 8) {
                this.setState({
                    noN_UNIFORM: [],
                    applicant: { ...this.state.applicant, name: [this.state.name, ...this.state.applicant.name], ...val },
                    currentstep: this.state.currentstep + 1,
                })
            }
            else
                this.setState({
                    applicant: { ...this.state.applicant, ...val },
                    defaultActiveKey: this.state.defaultActiveKey + 1
                })
        }
    };
    back = (type) => {
        if (type === "step") {
            this.setState({
                defaultActiveKey: 1,
                currentstep: this.state.currentstep - 1,

            })
        } else {
            this.setState({
                defaultActiveKey: this.state.defaultActiveKey - 1
            })
        }

    }
    Steps = () => {
        const { currentstep } = this.state;
        if (currentstep === 0&&this.state.predata) {
            return <Collapse className='niprcollapse' expandIcon={() => <></>} activeKey={[this.state.defaultActiveKey.toString()]} defaultActiveKey={[this.state.defaultActiveKey.toString()]}  >
                              <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} lassName='niprPanel' header="Biographic Data" key="1" >
                    <BiographicData predata={this.state.predata} niprappoinment={this.state.applicant} submitHandler={this.submitHandler} ></BiographicData>
                </Panel>
                <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header="Address" key="2"  >
                    <Address  predata={this.state.predata} niprappoinment={this.state.applicant} stateabb={this.state.stateabb} getstatename={this.getstatename} States={this.state.States} submitHandler={this.submitHandler} back={this.back}></Address>
                </Panel>
                <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header="Phone Contact Data " key="3" >
                    <Contact  predata={this.state.predata} niprappoinment={this.state.applicant} submitHandler={this.submitHandler} back={this.back}></Contact>
                </Panel>
                <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header="Web Information" key="4" >
                    <WebInformation  predata={this.state.predata} niprappoinment={this.state.applicant} submitHandler={this.submitHandler} back={this.back}></WebInformation>
                </Panel>
                <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header=" Aliases " key="5" >
                    <Aliases niprappoinment={this.state.applicant} submitHandler={this.submitHandler} back={this.back}></Aliases>
                </Panel>
                <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header=" Affiliations  " key="6" >
                    <Affiliations States={this.state.States} niprappoinment={this.state.applicant} submitHandler={this.submitHandler} back={this.back}></Affiliations>
                </Panel>
                <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header=" Employment History  " key="7" >
                    <NiprEmploymentHistory States={this.state.States} niprappoinment={this.state.applicant} submitHandler={this.submitHandler} back={this.back}></NiprEmploymentHistory>
                </Panel>
                <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header="Background" key="8" >
                    {this.state.bqs.length > 0 ?
                        <NiprBQ niprappoinment={this.state.applicant} bqs={this.state.bqs} submitHandler={this.submitHandler} back={this.back}></NiprBQ>
                        : ""}
                </Panel>
                {this.state.nuqs.length > 0 ?
                    <Panel className='niperpanel' style={{ fontWeight: "700", fontSize: "18px" }} header={"Questions" + (this.state.stateName ? ": " + this.state.stateName : "")} key="9" >
                        <NiprNQ nuqs={this.state.nuqs} submitHandler={this.submitHandler} back={this.back} noN_UNIFORM={this.state.noN_UNIFORM}></NiprNQ>
                    </Panel> : ""}
            </Collapse>
        } else if (currentstep === 1) {
            return <NiprSummary States={this.state.States} nuqs={this.state.nuqs} bqs={this.state.bqs} appoinment={this.state.applicant} noN_UNIFORM={this.state.noN_UNIFORM} back={this.back} submitHandlerStep={this.submitHandlerStep}></NiprSummary>;
        }
        else if (currentstep === 2) {
            return <NiprAttestation niprappoinment={this.state.applicant} niprresp={this.state.niprresp} back={this.back} submitHandlerStep={this.submitHandlerStep}></NiprAttestation>;
        }
        else if (currentstep === 3) {
            return this.state.niprresp ? <NiprRes niprresp={this.state.niprresp}></NiprRes> : "";

           // return <Paypal state={this.props.location.state} submitHandlerStep={this.submitHandlerStep}></Paypal>;
        }
        // else if (currentstep === 4) {
        //     return this.state.niprresp ? <NiprRes niprresp={this.state.niprresp}></NiprRes> : "";

        // }

    }
    render() {
        let { niprresp } = this.state;
        return (<div className="mi_main_div" >
            {niprresp &&(niprresp.error.length>0||(niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.response &&niprresp.transaction.license.response.resP_MESSAGE.filter(x => x.commenT_CODE !== "1")&& niprresp.transaction.license.response.resP_MESSAGE.filter(x => x.commenT_CODE !== "1").length>0)
            ||(niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.loa && niprresp.transaction.license.loa.response && niprresp.transaction.license.loa.response.resP_MESSAGE.filter(x => x.commenT_CODE !== "1").length>0))? (
               
               <Modal visible={niprresp}>
                    <div className="mi_model_popup">

                        <Row>
                            {niprresp && niprresp.error ?
                                <Col sm={24} >
                                    <p className="mi_title" style={{ marginLeft: '10px' }}>
                                        Action Required              </p>
                                </Col> : ""}
                            <Col sm={24}>
                                {niprresp && niprresp.error && niprresp.error.map(x => {
                                    return <p style={{ fontSize: '15px', color: 'red' }}> {x.erroR_CODE + ") " + x.description}</p>
                                })}

                                {niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.response && niprresp.transaction.license.response.resP_MESSAGE.filter(x => x.commenT_CODE !== "1").map(x => {
                                    return <p style={{ fontSize: '15px', color: 'red' }}> {x.commenT_CODE + ") " + x.comments}</p>
                                })}

                                {niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.loa && niprresp.transaction.license.loa.response && niprresp.transaction.license.loa.response.resP_MESSAGE.filter(x => x.commenT_CODE !== "1").map(x => {
                                    return <p style={{ fontSize: '15px', color: 'red' }}> {x.commenT_CODE + ") " + x.comments}</p>
                                })}

                            </Col>
                        </Row>
                        <Row span={24} style={{ marginTop: '20px' }}>
                            <Col span={7} ></Col>
                            <Col span={5} >
                                <Button className="mi_button_right submit-button" onClick={() => { this.setState({ niprresp: null }) }} style={{ marginRight: 8 }}>
                                    Cancel
                                </Button>
                            </Col>
                            <Col span={5} >
                                <Button onClick={() => { this.setState({ niprresp: null }) }} className="submit-button" type="primary" >
                                    Submit
                                </Button>
                            </Col>
                            <Col span={7} >
                            <img alt="example" style={{ width: 105,marginBottom:'-28px',float:'right' }} src={img} />

                            </Col>
                        </Row>
                    </div>
                </Modal>
            ) : null}
            <Row>
                <Col sm={24} md={8}>
                    <p className="mi_title" style={{ marginLeft: '10px' }}>
                        My NIPR              </p>
                </Col></Row>
            {this.state.isloding ?
                <div style={{ textAlign: 'center', position: 'fixed',top:"40%",left:"50%" }}>
                    <Spin size="large" />
                </div>
                : ""}
            {this.Steps()}
        </div>)
    }

}
export default MyNipr;
